import React, { useState } from 'react';
import { youtubeEmbedUrl, youtubeId, youtubeThumbnail } from '../utils/helpVideos';
import '../styles/HelpVideos.css';

// Liste des vidéos d'un guide : miniature cliquable, le lecteur YouTube
// n'est chargé qu'au clic (page légère, pas de cookies avant lecture).
const HelpVideoList = ({ videos, watchLabel }) => {
  const [playingId, setPlayingId] = useState(null);

  return (
    <ul className="help-video-list">
      {videos.map((video, index) => {
        const id = youtubeId(video.youtube);
        const isPlaying = playingId === `${id}-${index}`;
        return (
          <li key={`${id}-${index}`} className="help-video-item">
            <div className="help-video-frame">
              {isPlaying ? (
                <iframe
                  src={youtubeEmbedUrl(id)}
                  title={video.title || 'YouTube'}
                  allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                  allowFullScreen
                />
              ) : (
                <button
                  type="button"
                  className="help-video-thumb"
                  onClick={() => setPlayingId(`${id}-${index}`)}
                  aria-label={`${watchLabel} : ${video.title}`}
                >
                  <img src={youtubeThumbnail(id)} alt="" loading="lazy" />
                  <span className="help-video-play" aria-hidden="true">▶</span>
                </button>
              )}
            </div>
            {video.title && <p className="help-video-title">{video.title}</p>}
          </li>
        );
      })}
    </ul>
  );
};

export default HelpVideoList;
